<template>
	<!-- componente que se usa asignar o reasignar solicitudes -->
	<div>
		<CRow class="justify-content-center">
			<CCol sm="12">
				<CCard>
					<CCardHeader style="background: #97ca3d; color: black;">
						<h3>
							{{ title }}
						</h3>
					</CCardHeader>
					<CCardBody>
						<CRow>
							<CCol sm="12">
								<p>
									Para
									{{
										typeAssigment === 'assigment'
											? 'asignar'
											: 'reasignar'
									}}
									solicitudes primero selecciona un analista
									de la lista, ingresa la cantidad de
									solicitudes que deseas asignarle y haz clic
									en el botón <b>Agregar</b>.
								</p>
								<p>
									Para eliminar un analista asignado puedes
									hacer clic en el ícono de la papelera (<i
										class="fas fa-trash-alt fa-sm"
									></i
									>) al lado del analista que deseas eliminar.
								</p>
							</CCol>
						</CRow>
						<!-- tabla para mostrar la cantidad de solicitudes asignadas y por asignar -->
						<CRow
							v-if="tableCantAssigned.length > 0"
							class="content-center"
						>
							<CCol sm="6">
								<b-table
									class="text-left"
									stacked="lg"
									fixed
									striped
									outlined
									hover
									bordered
									:items="tableCantAssigned"
									:fields="fieldsCantAssigned"
								>
								</b-table>
							</CCol>
						</CRow>
						<CRow class="justify-content-left">
							<CCol sm="3">
								<div role="group" class="form-group">
									<label for="urb">Analista</label>
									<multiselect
										:preselect-first="true"
										v-if="selectAnalists != null"
										v-model="selectedAnalist"
										:allow-empty="false"
										track-by="idUsers"
										label="name"
										:options="selectAnalists"
										:searchable="true"
										:close-on-select="true"
										:show-labels="false"
										placeholder="Seleccione"
									>
										<span slot="noResult"
											>Oops! No se encontró la opción
											deseada</span
										>
									</multiselect>
									<small>Selecciona el analista</small>
								</div>
							</CCol>
							<CCol sm="3">
								<CInput
									v-model="quantityToAsing"
									label="Cantidad a Asignar"
									description="Ingresa la cantidad a asignar"
								>
								</CInput>
							</CCol>
						</CRow>
						<CRow class="content-left">
							<!-- <CCol sm="1">
                                    <b-button @click="goToConsult" pill variant="info">Regresar</b-button>
                                </CCol> -->
							<br />
							<CCol sm="6">
								<b-button
									@click="addAnalist"
									v-if="quantityToAsing > 0"
									pill
									variant="success"
									>Agregar
								</b-button>
							</CCol>
						</CRow>
						<br />
						<CRow class="content-center">
							<CCol sm="6">
								<b-table
									v-if="tableAsign.length > 0"
									class="text-left"
									stacked="lg"
									fixed
									striped
									outlined
									hover
									bordered
									:items="tableAsign"
									:fields="fieldsAnalistsAsign"
								>
									<template #cell(actions)="row">
										<b-button
											@click="deleteAnalistAsigned(row)"
											variant="danger"
											size="sm"
											class="mr-1"
										>
											<i class="fas fa-trash-alt"></i>
										</b-button>
									</template>
								</b-table>
							</CCol>
						</CRow>
						<CRow class="content-center">
							<CCol sm="12">
								<!-- <b-button @click="goToConsult" pill variant="info">Regresar</b-button> -->
								<b-button pill @click="goBack" variant="info"
									>Regresar</b-button
								>
								<b-button
									@click="confirmAssigned"
									style="margin-left: 20px;"
									v-if="tableAsign.length > 0"
									pill
									variant="success"
									>Asignar</b-button
								>
							</CCol>
						</CRow>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
		<!-- modal de confrmacion al asignar -->
		<CModal
			:show.sync="modalAssignSucces"
			:close-on-backdrop="false"
			:centered="true"
			title="Asignación exitosa!!"
			size="lg"
			color="success"
			style="text-align:justify;"
		>
			<CRow class="justify-content-left">
				<CCol>
					<p>Se asignaron las solicitudes exitosamente</p>
				</CCol>
			</CRow>
			<template #header>
				<h6 class="modal-title">Asignación exitosa!!</h6>
				<CButtonClose @click="goTo" class="text-white" />
			</template>
			<template #footer>
				<b-button
					@click="goTo"
					pill
					variant="success"
					size="lg"
					class="mr-1"
					>Cerrar
				</b-button>
			</template>
		</CModal>
		<!-- modal para mostrar errores -->
		<CModal
			:show.sync="modalForErrors"
			:close-on-backdrop="true"
			:centered="true"
			title="Oops!! Ocurrió un error!!"
			size="lg"
			color="danger"
			style="text-align:justify;"
		>
			<CRow>
				<CCol v-if="typeof errorsFound === 'string'">
					<p>
						<b>{{ errorsFound }}</b>
					</p>
				</CCol>
				<CCol v-else>
					<div
						v-for="(value, key, index) in errorsFound"
						:key="`${key}-${index}`"
					>
						<!-- <span>{{value}}</span> -->
						<div v-for="item in value" :key="item.id">
							<span
								><b>{{ item }}</b></span
							><br />
						</div>
					</div>
				</CCol>
			</CRow>
			<CRow>
				<CCol>
					<span>
						Por favor cierra esta modal y verifica los datos
						ingresados.
					</span>
				</CCol>
			</CRow>
			<template #header>
				<h6 class="modal-title">Oops!! Ocurrió un error!!</h6>
				<CButtonClose
					@click="modalForErrors = false"
					class="text-white"
				/>
			</template>
			<template #footer>
				<b-button
					@click="
						modalForErrors = false;
						tableAsign = [];
					"
					pill
					variant="warning"
					size="lg"
					class="mr-1"
					>Cerrar
				</b-button>
			</template>
		</CModal>
	</div>
</template>
<script>
	import assigmentRequests from '../functions/functionsAssigment';
	export default {
		/**Componente encargado de manejar la asignación/re asignación de usuarios a las solicitudes recibidas. */
		name: 'AssigmentRequest',
		props: {
			/*
			 *prop para el tipo de asignacion.
			 *si es reasignacion se manda el string "reassigment" or defecto es assigment para asignaciones
			 */
			typeAssigment: {
				type: String,
				default: function() {
					return 'assigment';
				},
			},
			/*
			 *prop para el id del request a asignar
			 */
			idRequest: {
				type: Number,
				default: function() {
					return 0;
				},
			},
			/*
			 *prop para el id del usuario
			 */
			idUser: {
				type: Number,
				default: function() {
					return 0;
				},
			},
			title: {
				type: String,
				default: function() {
					return 'Asignar Solicitudes a Analistas';
				},
			},
			requestsAssigned: {
				type: Number,
				default: function() {
					return 0;
				},
			},
			requestsUpdate: {
				type: Number,
				default: function() {
					return 0;
				},
			},
			totalRequestsAssigned: {
				type: Number,
				default: function() {
					return 0;
				},
			},
		},
		data() {
			return {
				showAssing: false,
				selectAnalists: null,
				selectedAnalist: null,
				quantityToAsing: 0,
				fieldsAnalistsAsign: [
					{
						key: 'name',
						label: 'Analista',
					},
					{
						key: 'quantity',
						label: 'Cantidad Asignada',
					},
					{
						key: 'actions',
						label: 'Acciones',
					},
				],
				tableAsign: [],
				fieldsCantAssigned: [
					{
						key: 'forAssign',
						label: 'Solicitudes por Asignar',
					},
					{
						key: 'assigned',
						label: 'Solicitudes Asignadas',
					},
				],
				tableCantAssigned: [],
				idRequestForAsign: this.idRequest,
				modalAssignSucces: false,
				errorMessage: '',
				modalForErrors: false,
				errorsFound: null,
			};
		},
		created() {
			let loader = this.$loading.show();
			//if (this.requestsUpdate > 0 && this.requestsAssigned) {
			let objetForTableCantAssigned = {};
			objetForTableCantAssigned = {
				forAssign: this.requestsUpdate - this.totalRequestsAssigned,
				assigned: this.requestsAssigned,
			};
			this.tableCantAssigned.push(objetForTableCantAssigned);
			//}
			assigmentRequests
				.getAnalists()
				.then((response) => {
					this.selectAnalists = response;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					loader.hide();
				});
		},
		methods: {
			addAnalist() {
				let newObject = {};
				let existAnalist = false;
				if (this.tableAsign.length > 0) {
					let analistName = this.selectedAnalist.name;
					existAnalist = this.tableAsign.some(function(ele) {
						return ele.name === analistName;
					});
				}
				if (!existAnalist) {
					newObject = {
						name: this.selectedAnalist.name,
						quantity: this.quantityToAsing,
						iduser: this.selectedAnalist.idUsers,
					};
					this.tableAsign.push(newObject);
				}
			},
			deleteAnalistAsigned(value) {
				let index = value.index;
				this.tableAsign.splice(index, 1);
			},
			confirmAssigned() {
				let loader = this.$loading.show();
				let objectAssigned = {
					assined: this.tableAsign.map(function(item) {
						delete item.name;
						return item;
					}),
				};
				if (this.typeAssigment == 'reassigment') {
					assigmentRequests
						.toReAssign(this.idRequest, objectAssigned, this.idUser)
						.then((response) => {
							this.modalAssignSucces = true;
						})
						.catch((error) => {
							console.log(error);
							let errorCode = error.response.data.code;
							switch (errorCode) {
								case 422:
									this.errorsFound =
										error.response.data.error;
									this.modalForErrors = true;
									break;
							}
						})
						.finally(() => {
							loader.hide();
						});
				} else {
					assigmentRequests
						.toAssign(this.idRequest, objectAssigned)
						.then((response) => {
							this.modalAssignSucces = true;
						})
						.catch((error) => {
							console.log(error);
							let errorCode = error.response.data.code;
							switch (errorCode) {
								case 422:
									this.errorsFound =
										error.response.data.error;
									this.modalForErrors = true;
									break;
							}
						})
						.finally(() => {
							loader.hide();
						});
				}
			},
			goTo() {
				if (this.typeAssigment == 'reassigment') {
					this.$parent.showViewProgress = false;
					this.$parent.showAssing = false;
					this.$parent.showConsult = true;
					this.$parent.loadData();
				} else {
					this.$parent.showAssing = false;
					this.$parent.showConsult = true;
					this.$parent.loadData();
				}
			},
			goBack() {
				if (this.typeAssigment == 'reassigment') {
					this.$parent.showViewProgress = true;
					this.$parent.showAssing = false;
				} else {
					this.$parent.showConsult = true;
					this.$parent.showAssing = false;
				}
			},
		},
	};
</script>
